// extracted by mini-css-extract-plugin
export var aircallIframe = "_ji-3";
export var fabContainer = "_ji-5";
export var fabRinging = "_ji-6";
export var loadingOverlay = "_ji-4";
export var pulse = "_ji-7";
export var widgetContent = "_ji-2";
export var widgetPanel = "_ji-0";
export var widgetPanelExpanded = "_ji-1";